// ============================================================
// home-search/premium-detector.js — Detección de negocios Premium
// ============================================================

/**
 * Debug: loguea cómo se decide premium para un negocio en un contexto dado
 */
function debugPremium(b, context = 'unknown', decisionHint) {
  try {
    const exp = b?.premium_expires_at || b?.premiumExpiresAt;
    const t = exp ? Date.parse(exp) : NaN;
    const expFuture = !!exp && !Number.isNaN(t) && t > Date.now();
    const planFlag = (
      b?.is_premium === true ||
      b?.isPremium === true ||
      b?.premium === true ||
      b?.membership === 'premium' ||
      b?.owner_role === 'premium' ||
      b?.ownerRole === 'premium' ||
      b?.plan === 'premium' ||
      (b?.premium_plan != null && String(b?.premium_plan).trim() !== '') ||
      (b?.premiumPlan != null && String(b?.premiumPlan).trim() !== '')
    );
    console.log(`🧪 [PREMIUM DEBUG] ctx=${context} name=${b?.name || '(sin nombre)'} -> decision=${decisionHint}`, {
      premium_plan: b?.premium_plan,
      premiumPlan: b?.premiumPlan,
      premium_expires_at: b?.premium_expires_at,
      premiumExpiresAt: b?.premiumExpiresAt,
      expFuture,
      is_premium: b?.is_premium,
      isPremium: b?.isPremium,
      premium: b?.premium,
      membership: b?.membership,
      owner_role: b?.owner_role,
      ownerRole: b?.ownerRole,
      plan: b?.plan,
      planFlag
    });
  } catch (_) { /* noop */ }
}

/**
 * Verifica si un negocio es premium.
 * Acepta tanto snake_case como camelCase provenientes del backend.
 */
export function isPremium(b) {
  try {
    const flag = (
      b?.is_premium === true ||
      b?.isPremium === true ||
      b?.premium === true ||
      b?.membership === 'premium' ||
      b?.owner_role === 'premium' ||
      b?.ownerRole === 'premium' ||
      b?.plan === 'premium' ||
      (b?.premium_plan != null && String(b?.premium_plan).trim() !== '') ||
      (b?.premiumPlan != null && String(b?.premiumPlan).trim() !== '')
    );
    const exp = b?.premium_expires_at || b?.premiumExpiresAt;
    if (exp) {
      const t = Date.parse(exp);
      if (!Number.isNaN(t) && t > Date.now()) {
        try { debugPremium(b, 'isPremium(expiry)', true); } catch(_) {}
        return true;
      }
    }
    try { debugPremium(b, 'isPremium(flag)', !!flag); } catch(_) {}
    return flag;
  } catch (_) {
    return false;
  }
}

/**
 * Obtiene la etiqueta premium (PREMIUM o FREEMIUM)
 */
export function getPremiumLabel(b) {
  try {
    let pf = b?.premium_features;
    if (!pf && b?.premiumFeatures) pf = b.premiumFeatures;
    if (typeof pf === 'string' && pf.trim()) {
      try { pf = JSON.parse(pf); } catch { pf = null; }
    }
    const src = (b?.premium_source || b?.premiumSource || pf?._premium_source || pf?.premium_source || pf?.source || '').toString().toLowerCase();
    const isFreemium = b?.is_freemium === true || b?.isFreemium === true || src === 'gift';
    return isFreemium ? 'FREEMIUM' : 'PREMIUM';
  } catch {
    return 'PREMIUM';
  }
}
